export default {
  all: [],
  currentlySelected: { user: {} }
}
